import { DataFetchingClient } from 'data-fetching-client';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
export const handleGetObjectTypeById = (objectTypeId, options = {}) => {
  const client = options.client || new DataFetchingClient();
  const clientQuery = client.query({
    query: GET_OBJECT_TYPE_BY_ID,
    variables: {
      objectTypeId
    }
  }).then(response => response.data.objectTypeById);
  return clientQuery;
};